import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled/macro'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import useDarkMode from 'use-dark-mode'
import mq from 'mediaQuery'
import Step from './Step'
import Progress from './Progress'
import Img1d from '../../../assets/Images/one.png'
import Img2d from '../../../assets/Images/two.png'
import Img3d from '../../../assets/Images/three.png'
import CheckImgd from '../../../assets/Images/check.png'
import Img1w from '../../../assets/Images/one_w.png'
import Img2w from '../../../assets/Images/two_w.png'
import Img3w from '../../../assets/Images/three_w.png'
import CheckImgw from '../../../assets/Images/check_w.png'
import useSWR from 'swr'
import { useLocale } from 'hooks'

const Explainer = ({ step, status, stepsHeaderText }) => {
  const { t } = useTranslation()
  const titles = {
    PRICE_DECISION: stepsHeaderText,
    COMMIT_SENT: t('register.titles.1'),
    COMMIT_CONFIRMED: t('register.titles.1'),
    AWAITING_REGISTER: t('register.titles.1'),
    REVEAL_SENT: t('register.titles.1'),
    REVEAL_CONFIRMED: t('register.titles.2')
  }

  const darkMode = useDarkMode(true)
  const isDark = darkMode.value
  const Img1 = isDark ? Img1w : Img1d
  const Img2 = isDark ? Img2w : Img2d
  const Img3 = isDark ? Img3w : Img3d
  const CheckImg = isDark ? CheckImgw : CheckImgd

  const { locale } = useLocale()

  const fetcher = () =>
    fetch(
      `${
        process.env.REACT_APP_STRAPI_API_URL
      }/api/search-registration-processes?populate=img&locale=${locale}`
    ).then(response => response.json())

  const { data } = useSWR([`api/search-registeration-steps`, locale], fetcher)

  const isStep1Done = status[step] > 1
  const isStep2Done = status[step] > 2
  const isStep3Done = status[step] > 4

  return (
    <section>
      {step === 'PRICE_DECISION' && (
        <Wrapper>
          <H4Bold isDark={isDark}>{titles[step]}</H4Bold>
        </Wrapper>
      )}
      {data?.data?.length > 2 && (
        <GridLayout>
          <Step
            image={isStep1Done ? CheckImg : Img1}
            title={data?.data[0]?.attributes.name}
            text={data?.data[0]?.attributes.content}
          />
          <Step
            image={isStep2Done ? CheckImg : Img2}
            title={data?.data[1]?.attributes.name}
            text={data?.data[1]?.attributes.content}
          />
          <Step
            image={isStep3Done ? CheckImg : Img3}
            title={data?.data[2]?.attributes.name}
            text={data?.data[2]?.attributes.content}
          />
        </GridLayout>
      )}
    </section>
  )
}

export default Explainer

const GridLayout = styled('div')`
  display: grid;
  align-items: center;
  justify-items: center;
  row-gap: 40px;

  ${mq.medium`
    grid-template-columns: repeat(3, 1fr);
    column-gap: 40px;
  `};

  ${mq.large`
    column-gap: 50px;
  `};

  ${mq.xLarge`
    column-gap: 100px;
  `};

  .grid-element {
    ${mq.medium`
      height: 100%;
    `};
  }
`

const H4Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 123.5%;
  letter-spacing: 0.25px;
  color: ${({ isDark }) => (isDark ? '#fff' : 'rgba(0, 0, 0, 0.87)')};
  margin-bottom: 35px;
  text-align: center;
`

const Wrapper = styled('div')`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
